import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { fmt } from "../lib/format";

export default function PatientMap({ points, onSelect }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const clusterRef = useRef(null);
  const onSelectRef = useRef(onSelect);
  onSelectRef.current = onSelect;

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    const map = L.map(elRef.current, { scrollWheelZoom: false }).setView([-6.2, 106.75], 10);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap',
    }).addTo(map);
    const cluster = L.markerClusterGroup({ maxClusterRadius: 45 });
    map.addLayer(cluster);
    mapRef.current = map;
    clusterRef.current = cluster;
    const t = setTimeout(() => { if (mapRef.current === map) map.invalidateSize(); }, 200);
    return () => { clearTimeout(t); map.remove(); mapRef.current = null; clusterRef.current = null; };
  }, []);

  useEffect(() => {
    const cluster = clusterRef.current, map = mapRef.current;
    if (!cluster || !map) return;
    cluster.clearLayers();
    if (!points || points.length === 0) return;
    const maxP = Math.max(...points.map((p) => p.patients)) || 1;
    points.forEach((p) => {
      const radius = 7 + 20 * Math.sqrt(p.patients / maxP);
      const marker = L.circleMarker([p.lat, p.lng], {
        radius, color: "#1C4A37", weight: 1.5, fillColor: "#5FA777", fillOpacity: 0.8,
      });
      marker.bindPopup(
        `<div style="font-family:sans-serif"><strong>${p.kecamatan}</strong><br/>${p.kota}, ${p.provinsi}<br/><b>${fmt(p.patients)}</b> pasien<br/><span style="color:#3E7C5A;font-size:11px">Klik untuk lihat detail →</span></div>`
      );
      marker.on("click", () => { onSelectRef.current && onSelectRef.current(p); });
      cluster.addLayer(marker);
    });
    try {
      map.fitBounds(L.latLngBounds(points.map((p) => [p.lat, p.lng])).pad(0.2));
    } catch { /* ignore */ }
    const t = setTimeout(() => { if (mapRef.current === map) map.invalidateSize(); }, 100);
    return () => clearTimeout(t);
  }, [points]);

  return <div ref={elRef} className="w-full h-[420px] rounded-xl overflow-hidden ring-1 ring-border relative z-0" data-testid="patient-map" />;
}
